import {
  AlertCircleIcon_default
} from "./chunk-PHTCP5GI.esm.js";

// src/components/forms/SxInput/SxInput.tsx
import {
  FormControl,
  FormLabel,
  FormHelperText,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement
} from "@chakra-ui/react";

// src/components/forms/SxInput/SxInput.styles.ts
var inputStyles = {
  display: "block",
  minHeight: "64px",
  width: "100%",
  padding: "1rem 0.75rem",
  border: "1px solid",
  borderColor: "neutral.300",
  borderRadius: 0,
  appearance: "none",
  lineHeight: 1.25,
  color: "neutral.600",
  _focus: {
    borderColor: "neutral.black",
    boxShadow: "0 0 0 1px #0F0F0F",
    paddingTop: "2rem",
    paddingBottom: "0.75rem",
    _invalid: {
      borderColor: "red.700",
      boxShadow: "0 0 0 1px #AB1615"
    }
  },
  _hover: {
    borderColor: "neutral.300"
  },
  _disabled: {
    bg: "neutral.white",
    borderColor: "neutral.300",
    cursor: "not-allowed",
    "~label": {
      color: "neutral.300"
    }
  },
  _placeholder: {
    opacity: 0
  },
  _invalid: {
    borderColor: "red.700",
    boxShadow: "0 0 0 1px #AB1615",
    paddingRight: 12
  },
  ":not(:placeholder-shown)": {
    paddingTop: "2rem",
    paddingBottom: "0.75rem"
  },
  ":focus~label": {
    transform: "scale(.75) translateY(-0.5rem) translateX(0.15rem)"
  },
  ":not(:placeholder-shown)~label": {
    transform: "scale(.75) translateY(-0.5rem) translateX(0.15rem)"
  }
};
var labelStyles = {
  display: "inline-block",
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  padding: "1.25rem 0.75rem",
  margin: 0,
  pointerEvents: "none",
  border: "1px solid transparent",
  transformOrigin: "0 0",
  transition: "transform .1s ease-in-out",
  color: "neutral.500"
};

// src/components/forms/SxInput/SxInput.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SxInput = ({
  inputLabel,
  errorMessage,
  isDisabled,
  isRequired,
  isInvalid,
  helperText,
  ...props
}) => {
  const inputId = inputLabel.replace(/[^a-zA-Z0-9]/g, "");
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      p: "relative",
      isRequired,
      isInvalid,
      isDisabled,
      sx: {
        ".chakra-form__required-indicator": {
          color: "inherit"
        }
      },
      children: [
        /* @__PURE__ */ jsxs(InputGroup, { children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              id: inputId,
              size: "sm",
              placeholder: inputLabel,
              sx: inputStyles,
              ...props
            }
          ),
          isInvalid && /* @__PURE__ */ jsx(
            InputRightElement,
            {
              top: "2",
              right: "3",
              children: /* @__PURE__ */ jsx(AlertCircleIcon_default, { color: "red.700", boxSize: 7 })
            }
          ),
          /* @__PURE__ */ jsx(FormLabel, { htmlFor: inputId, size: "sm", sx: labelStyles, children: inputLabel })
        ] }),
        errorMessage && /* @__PURE__ */ jsx(FormErrorMessage, { color: "red.700", children: errorMessage }),
        helperText && !isInvalid && /* @__PURE__ */ jsx(FormHelperText, { color: "neutral.500", children: helperText })
      ]
    }
  );
};
var SxInput_default = SxInput;

export {
  SxInput_default
};
